<template>
    <div class="mission-detail-page">
        <div class="page-title">
            <img src="../../assets/jike/back.png" />{{
                type === "edit" ? "修改" : ""
            }}即刻任务<img src="../../assets/jike/sd.png" width="16" />
        </div>
        <div class="mission-section">
            <p class="mission-section-title">
                <span>品牌及店铺</span>
            </p>
            <form-item item-label="任务品牌：">
                <span>{{ missionDetail.brandName }}</span>
            </form-item>
            <form-item item-label="选择店铺：">
                <div class="shop-box border-box">
                    <div class="img-box">
                        <img src="../../assets/jike/bshop.png" width="40" />
                    </div>
                    <div class="shop-info-box">
                        <p class="shop-name">{{ addressInfo.realName }}</p>
                        <p>
                            <img
                                class="samall"
                                src="../../assets/jike/map.png"
                                alt=""
                            />{{ addressInfo.name }} {{ addressInfo.phone }}
                        </p>
                        <p style="display: inline-flex">
                            <img
                                class="samall"
                                src="../../assets/jike/phone.png"
                                alt=""
                            />{{ addressInfo.province }}{{ addressInfo.city
                            }}{{ addressInfo.district
                            }}{{ addressInfo.address }}
                        </p>
                    </div>
                </div>
            </form-item>
        </div>
        <div class="mission-section">
            <p class="mission-section-title">
                <span>赠送商品</span>
            </p>
            <form-item>
                <div
                    class="table-box border-box"
                    v-if="
                        missionDetail.products &&
                        missionDetail.products.length > 0
                    "
                >
                    <div class="img-box">
                        <img
                            :src="`https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/${missionDetail.products[0].imageUrl}`"
                            width="80"
                        />
                    </div>
                    <div class="table-info-box good-info-box">
                        <p>商品：{{ missionDetail.products[0].name }}</p>
                        <p>
                            价值：{{
                                missionDetail.products[0].price | priceFilter
                            }}元
                        </p>
                    </div>
                    <span
                        class="switch-product-btn"
                        v-if="type === 'edit'"
                        @click="switchProduct"
                        >修改</span
                    >
                </div>
            </form-item>
        </div>
        <div class="mission-section">
            <p class="mission-section-title">
                <span>具体要求</span>
            </p>
            <form-item>
                <van-field
                    :class="type === 'edit' ? 'showBorder' : ''"
                    :right-icon="type === 'edit' ? 'arrow-down' : ''"
                    readonly
                    clickable
                    name="picker"
                    :value="missionDetail.platform | platFilter"
                    label="发文平台:"
                    placeholder="点击选择平台"
                    @click="handlePlat"
                />
                <van-popup v-model="showPicker" position="bottom">
                    <van-picker
                        :default-index="activePlat"
                        show-toolbar
                        value-key="name"
                        :columns="columns"
                        @confirm="onConfirm"
                        @cancel="showPicker = false"
                    />
                </van-popup>
            </form-item>
            <form-item>
                <van-field
                    type="digit"
                    :class="type === 'edit' ? 'showBorder' : ''"
                    :autofocus="type === 'edit'"
                    :readonly="type === 'info'"
                    v-model="missionDetail.needPeople"
                    label="需要人数:"
                    placeholder="请输入需要人数"
                >
                    <template #button>
                        <van-button style="border: none" size="small"
                            >人</van-button
                        >
                    </template>
                    <!--                    <template #extra>人</template>-->
                </van-field>
            </form-item>
            <form-item :item-label="type === 'edit' ? '任务结束时间' : ''">
                <div class="border-box radio-box" v-if="type === 'edit'">
                    <van-radio-group v-model="radio">
                        <van-row>
                            <van-col :span="12">
                                <van-radio name="3">
                                    3小时后
                                    <template #icon="props">
                                        <img
                                            class="img-icon"
                                            :src="
                                                props.checked
                                                    ? activeIcon
                                                    : inactiveIcon
                                            "
                                        />
                                    </template>
                                </van-radio>
                            </van-col>
                            <van-col :span="12">
                                <van-radio name="6">
                                    6小时后
                                    <template #icon="props">
                                        <img
                                            class="img-icon"
                                            :src="
                                                props.checked
                                                    ? activeIcon
                                                    : inactiveIcon
                                            "
                                        />
                                    </template>
                                </van-radio>
                            </van-col>
                        </van-row>
                        <van-row>
                            <van-col :span="12">
                                <van-radio name="12">
                                    12小时后
                                    <template #icon="props">
                                        <img
                                            class="img-icon"
                                            :src="
                                                props.checked
                                                    ? activeIcon
                                                    : inactiveIcon
                                            "
                                        />
                                    </template>
                                </van-radio>
                            </van-col>
                            <van-col :span="12">
                                <van-radio name="24">
                                    24小时后
                                    <template #icon="props">
                                        <img
                                            class="img-icon"
                                            :src="
                                                props.checked
                                                    ? activeIcon
                                                    : inactiveIcon
                                            "
                                        />
                                    </template>
                                </van-radio>
                            </van-col>
                        </van-row>
                    </van-radio-group>
                </div>
                <van-field
                    v-else
                    readonly
                    :value="`${resolveTime}小时后`"
                    label="任务结束时间"
                    placeholder=""
                >
                </van-field>
            </form-item>
            <form-item item-label="任务名称">
                <span>{{ missionDetail.name }}</span>
            </form-item>
            <form-item item-label="详细要求">
                <div v-html="missionDetail.description"></div>
            </form-item>
        </div>
        <div class="mission-section button-wrapper">
            <van-button v-if="type === 'edit'" @click="cancelEdit"
                >取消</van-button
            >
            <van-button v-else @click="type = 'edit'">修改</van-button>
            <van-button
                v-if="type === 'edit' && optType === 'edit'"
                @click="confirmEdit"
                >确定修改</van-button
            >
            <van-button v-else @click="confirmAdd">确定发布</van-button>
        </div>
        <van-popup v-model="productShow" position="bottom">
            <!--            <van-card-->
            <!--                price="2.00"-->
            <!--                desc="描述信息"-->
            <!--                title="商品标题"-->
            <!--                thumb="https://img01.yzcdn.cn/vant/ipad.jpeg"-->
            <!--            />-->
            <div class="produst-list-wrapper">
                <div
                    class="table-box pop-good-box"
                    v-for="item in products"
                    :key="item.id"
                    @click="handleChoose(item)"
                >
                    <img
                        class="check-icon"
                        :src="
                            item.id === selectProduct
                                ? activeIcon
                                : inactiveIcon
                        "
                    />
                    <div class="img-box">
                        <img
                            :src="`https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/${item.imageUrl}`"
                            width="80"
                        />
                    </div>
                    <div class="table-info-box good-info-box">
                        <p>{{ item.name }}</p>
                        <p>价值：{{ item.price | priceFilter }}元</p>
                    </div>
                </div>
                <van-pagination
                    v-model="params.current"
                    :total-items="total"
                    :show-page-size="5"
                >
                    <template #prev-text>
                        <van-icon name="arrow-left" />
                    </template>
                    <template #next-text>
                        <van-icon name="arrow" />
                    </template>
                    <template #page="{ text }">{{ text }}</template>
                </van-pagination>
            </div>
            <div class="button-wrapper" style="margin-bottom: 20px">
                <van-button @click="productShow = false">取消</van-button>
                <van-button @click="confirmSwitch">确定修改</van-button>
            </div>
        </van-popup>
    </div>
</template>
<script>
import axios from "axios";
import FormItem from "./components/formItem";
import {
    fetchTaskDetail,
    fetchAddressById,
    fetchProductsByBrand,
    addTask,
    editTask,
} from "../../services/instant";
import moment from "moment";
import round from "lodash.round";
import cloneDeep from "lodash.clonedeep";
import _ from "underscore";
import { Toast } from "vant";

const plats = {
    50: "大众点评",
    60: "微信朋友圈",
};
export default {
    name: "MissionDetail",
    components: {
        FormItem,
    },
    filters: {
        platFilter(type) {
            return plats[type];
        },
        timeFilter(value) {
            return `${value}小时后`;
        },
        priceFilter(value) {
            if (!value) {
                return "0";
            }
            // 将整数部分逢三一断
            return round(value / 100)
                .toFixed(2)
                .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
        },
    },
    computed: {
        resolveTime() {
            if (this.missionDetail.status) {
                let date1;
                if (this.missionDetail.status.value === 5) {
                    date1 = moment(this.missionDetail.gmtModified);
                } else {
                    date1 = moment(this.missionDetail.gmtCreate);
                } // 任务创建时间
                const date2 = moment(this.missionDetail.applyEndTime); // 报名结束时间
                const date3 = date2.diff(date1, "minute"); // 计算相差的分钟数
                const h = Math.ceil(date3 / 60); // 相差的小时数
                return h;
            }
            return "";
        },
    },
    watch: {
        resolveTime(val) {
            if (val) {
                this.radio = String(val);
            }
        },
    },
    data() {
        return {
            optType: "",
            timeType: "add",
            activePlat: 0, // 默认选中平台
            missionDetail: {}, // 任务详情
            addressInfo: {}, // 店铺地址详情
            type: "info", // info 查看 edit 修改
            activeIcon: require("../../assets/jike/radioCheck.png"),
            inactiveIcon: require("../../assets/jike/radioUncheck.png"),
            radio: "3", // 时间切换
            showPicker: false, // 选择发文平台
            productShow: false, // 选择商品弹窗
            total: 0, // 商品数量
            params: {
                current: 1,
                size: 5,
                brandId: "",
            }, // 查询商品的参数
            columns: [
                {
                    type: 50,
                    name: "大众点评",
                },
                {
                    type: 60,
                    name: "微信朋友圈",
                },
            ],
            selectProduct: null,
            products: [
                {
                    id: 1,
                    name: "商品商品",
                    price: 100,
                },
                {
                    id: 2,
                    name: "商品商品",
                    price: 100,
                },
            ],
            missionForm: {
                brandName: "掌上韩品",
                shop: {
                    id: 1,
                    name: "嘻嘻嘻嘻嘻嘻嘻嘻",
                    linkPerson: "张三",
                    linkPhone: "15612451267",
                    address: "上海市蒙自路南京南路16号爱琴海商场二楼",
                },
                good: {
                    name: "商品商品",
                    price: 100,
                },
                needPeople: "100",
                platform: 1,
                missionName: "llallalalaa",
                description: "",
            },
        };
    },
    mounted() {
        const query = this.$route.query;
        this.getTaskDetail(query.id);
        this.optType = query.optType;
    },
    methods: {
        /*
        已完成的 -》再次发布 -》复制直接发布（免审核）
        已完成的/审核拒绝的 -》修改--》新增草稿-》发布
         */
        async getTaskDetail(id) {
            await fetchTaskDetail(id).then((res) => {
                const cloneData = _.clone(res);
                cloneData.type = cloneData.type.value;
                cloneData.platform = cloneData.platform.value;
                cloneData.marketType = cloneData.marketType.value;
                cloneData.marketHandleType = cloneData.marketHandleType.value;
                cloneData.labelIds = cloneData.labels.map((item) => item.id);
                this.missionDetail = cloneData;
                this.activePlat = this.columns.findIndex(
                    (item) => item.type === cloneData.platform
                );
                this.params.brandId = this.missionDetail.brandId;
                this.selectProduct =
                    this.missionDetail.products[0].merchantProductId;
            });
            this.addressInfo = await fetchAddressById(
                this.missionDetail.merchantAddressId
            );
            // this.addressInfo = shops.filter(item => item.id === this.missionDetail.addressMerchantId)[0]
        },
        // 查询店铺下商品
        getProducts() {
            fetchProductsByBrand(this.params).then((res) => {
                this.products = res.records;
                this.total = res.total;
            });
        },
        switchProduct() {
            this.getProducts();
            this.productShow = true;
        },
        handlePlat() {
            if (this.type === "edit") {
                this.showPicker = true;
            }
        },
        onConfirm(v) {
            console.log(v);
            this.missionDetail.platform = v.type;
            this.showPicker = false;
        },
        handleChoose(item) {
            this.selectProduct = item.id;
        },
        confirmSwitch() {
            this.missionDetail.products = this.products.filter(
                (item) => item.id === this.selectProduct
            );
            this.productShow = false;
        },
        // 取消修改
        cancelEdit() {
            this.type = "info";
            this.getTaskDetail(this.missionDetail.id);
        },
        // 确认修改，若是草稿，则修改草稿，若为已经发布的，新增草稿
        // 1 修改 2新增
        confirmEdit() {
            this.timeType = "edit";
            const requestParams = cloneDeep(this.missionDetail);
            // requestParams.status = 5
            if (this.missionDetail.status.value === 5) {
                requestParams.status = 10;
                this.addOrUpdateRequest(requestParams, 1);
                // 草稿箱
            } else {
                requestParams.status = 10;
                this.addOrUpdateRequest(requestParams, 1);
            }
        },
        confirmAdd() {
            this.timeType = "add";
            const requestParams = cloneDeep(this.missionDetail);
            requestParams.status = 10;
            // 点击发布，若是草稿，为修改任务+id， 若是任务，则是新增任务
            if (this.missionDetail.status.value === 5) {
                this.addOrUpdateRequest(requestParams, 1);
                // 草稿箱
            } else {
                this.addOrUpdateRequest(requestParams, 2);
            }
            // if (this.missionDetail.status.value === 5) {
            //     // 草稿箱
            // }
            //
        },
        async addOrUpdateRequest(requestParams, type) {
            // const timeVal = this.timeType === 'add' ? this.resolveTime : this.radio
            const nowDate = new Date().getTime();
            requestParams.applyEndTime = moment(
                nowDate + Number(this.radio) * 60 * 60 * 1000
            ).format("YYYY-MM-DD HH:mm:ss");
            requestParams.settleEndTime = moment(requestParams.applyEndTime)
                .add(7, "days")
                .format("YYYY-MM-DD HH:mm:ss");
            requestParams.taskApplyRules = [];
            requestParams.applyPeopleMax = requestParams.needPeople;
            requestParams.taskApplyRules.push({
                applyEndTime: requestParams.settleEndTime, // 报名结束时间
                applyPeopleMax: requestParams.applyPeopleMax, // 报名最大人数
                applyStartTime: requestParams.applyEndTime, // 报名开始时间
                needPeople: requestParams.needPeople, // 需要人数
            });
            if (!requestParams.products[0].merchantProductId) {
                requestParams.products[0].merchantProductId =
                    requestParams.products[0].id;
            }
            const instance = axios.create({
                transformRequest: [
                    (data, headers) => {
                        delete headers.timestamp;
                        delete headers.token;
                        delete headers.sign;
                    },
                ],
            });
            await instance
                .get("https://restapi.amap.com/v3/geocode/regeo", {
                    params: {
                        location: `${this.addressInfo.longitude},${this.addressInfo.latitude}`,
                        key: "752eaa74f91b77532a2651d14e3fa77a",
                        radius: "0",
                        extensions: "all",
                        batch: false,
                    },
                })
                .then((res) => {
                    // businessAreas
                    const data = res.data.regeocode.addressComponent;
                    console.log(
                        data,
                        data.businessAreas.length,
                        typeof data.businessAreas[0]
                    );
                    if (
                        data.businessAreas.length > 0 &&
                        data.businessAreas[0].length !== 0
                    ) {
                        console.log(333);
                        requestParams.business = data.businessAreas[0].name;
                        console.log(requestParams.business);
                        //
                    } else {
                        requestParams.business = data.township;
                        // data.township
                    }
                });
            let request = null;
            let subType = "";
            let message = "";
            if (requestParams.status === 5) {
                // 新增草稿或修改任务
                if (type === 1) {
                    subType = "edit";
                    message = "修改中...";
                    request = editTask(requestParams);
                } else {
                    subType = "add";
                    message = "存为草稿中...";
                    request = addTask(_.omit(requestParams, "id"));
                }
            } else {
                // 发布任务
                subType = "add";
                message = "发布中...";
                if (type === 1) {
                    request = editTask(requestParams);
                } else {
                    if (this.optType === "copy") {
                        requestParams.copyTaskId = requestParams.id;
                    }
                    request = addTask(_.omit(requestParams, "id"));
                }
            }
            Toast.loading({
                duration: 0,
                message: message,
                forbidClick: true,
                loadingType: "spinner",
            });
            request
                .then((res) => {
                    if (res.code === 0) {
                        if (subType === "edit") {
                            this.getTaskDetail(requestParams.id);
                            this.type = "info";
                        } else {
                            this.$eventBus.$emit("refresh_task_list");
                            this.$router.back();
                        }
                        // 修改成功
                    }
                })
                .finally(() => {
                    Toast.clear();
                });
        },
    },
};
</script>
<style lang="less" scoped>
.showBorder {
    /deep/.van-field__body {
        border: 1px solid #000000;
        border-radius: 4px;
        padding: 0 5px;
    }
}
.samall {
    height: 16px;
    width: 16px;
    position: relative;
    top: 3px;
    right: 2px;
}
.mission-detail-page {
    /deep/.van-cell {
        line-height: 30px;
        padding: 0;
        .van-field__label {
            color: #878787;
        }
    }
    /deep/.van-cell--clickable:active {
        background-color: #ffffff;
    }
    background: #f1f1f1;
    .switch-product-btn {
        position: absolute;
        cursor: pointer;
        color: #1677ff;
        font-size: 12px;
        right: 20px;
        top: 10px;
        line-height: 20px;
    }
    .produst-list-wrapper {
        padding: 20px;
        .pop-good-box {
            padding-left: 30px;
            border-bottom: 1px solid #cac6c6;
            .check-icon {
                position: absolute;
                left: 0;
                top: 50%;
                width: 20px;
                margin-top: -10px;
            }
            &:last-child {
                border-bottom: none;
            }
        }
    }
    .button-wrapper {
        text-align: center;
        .van-button {
            width: 90px;
            height: 35px;
            box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
            border-radius: 4px;
            &:nth-of-type(1) {
                margin-right: 20px;
                border: 1px solid #979797;
            }
            &:nth-of-type(2) {
                background: linear-gradient(180deg, #17c1ce 0%, #17ce92 100%);
                color: white;
            }
        }
    }
    .page-title {
        padding: 0 10px;
        line-height: 36px;
        background: #ffffff;
        font-weight: bold;
        font-size: 18px;
        color: #333333;
        border-bottom: 1px solid #dadada;
        img {
            vertical-align: middle;
            margin-right: 10px;
        }
    }
    .radio-box {
        .van-radio {
            padding-left: 30px;
        }
        /deep/.van-col {
            padding: 15px 0;
            text-align: center;
        }
    }
    .img-icon {
        width: 18px;
    }
    .mission-section {
        background: white;
        margin-bottom: 8px;
        padding: 10px;
        &-title {
            text-align: center;
            margin-bottom: 30px;
            span {
                font-weight: bold;
                padding: 0 10px 5px;
                border-bottom: 1px solid #ff6d26;
            }
        }
    }
}
.border-box {
    margin: 0 auto;
    width: 350px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #000000;
}
.table-box {
    position: relative;
    .img-box {
        display: table-cell;
        padding: 0 10px;
        vertical-align: middle;
    }
    .table-info-box {
        display: table-cell;
    }
}
.shop-box {
    position: relative;
    padding: 10px 0;

    .img-box {
        display: table-cell;
        padding: 0 10px;
        vertical-align: middle;
    }
    .shop-info-box {
        display: table-cell;

        p {
            font-size: 12px;
            margin: 0;
            line-height: 24px;

            &.shop-name {
                font-weight: bold;
                color: #000;
                line-height: 24px;
            }

            &:nth-of-type(2),
            &:nth-of-type(3) {
                color: #999999;
                line-height: 20px;
            }
        }
    }
}
</style>
